import * as F from "fp-ts/function"
import * as E from "fp-ts/Either"
import { Either } from "fp-ts/Either"
import { Type } from "io-ts"
import * as GenericError from "./generic-error"

type Decoder<T> = (a: unknown) => Either<GenericError.GenericError, T>
export const decode = <T>(type: Type<T, unknown>): Decoder<T> =>
    F.flow(type.decode, E.mapLeft(GenericError.fromValidation(`Unable to decode ${type.name}`)))
